const ERROR_COMPONENT_DEFAULT_IMAGE = 'illustration_confirmation_error',
  ERROR_COMPONENT_DECLINED_IMAGE = 'illustration_emptystates_on-hold',
  ERROR_COMPONENT_STATES_IMAGE = 'illustration_emptystates_no-items';

export {
  ERROR_COMPONENT_DECLINED_IMAGE,
  ERROR_COMPONENT_DEFAULT_IMAGE,
  ERROR_COMPONENT_STATES_IMAGE,
};
